type FlattenedObject = { [key: string]: any };

export const flattenObject = (
	data: any,
	parentKey: string = '',
	separator: string = '.',
): FlattenedObject => {
	const flattened: FlattenedObject = {};
	const obj = { ...data };
	for (const key in obj) {
		if (Object.hasOwn(obj, key)) {
			const newKey = parentKey ? `${parentKey}${separator}${key}` : key;
			if (
				typeof obj[key] === 'object' &&
				obj[key] !== null &&
				!Array.isArray(obj[key])
			) {
				Object.assign(flattened, flattenObject(obj[key], newKey, separator));
			} else if (
				typeof obj[key] === 'object' &&
				obj[key] !== null &&
				Array.isArray(obj[key])
			) {
				obj[key].forEach((value: any, index: number) => {
					if (typeof value === 'object' && value !== null) {
						Object.assign(
							flattened,
							flattenObject(value, `${newKey}.${index}`, separator),
						);
					} else if (value !== null) {
						flattened[`${newKey}.${index}`] = value;
					}
				});
			} else {
				flattened[newKey] = obj[key];
			}
		}
	}
	return flattened;
};
